import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from '@/config';

import type { Recipe, VerbConjugation } from './types';

export const api = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({ baseUrl: `${config.apiHost}/REST/` }),
    endpoints: (build) => ({
        // The trailing slash matters: without it the server answers 301
        getRecipes: build.query<Recipe[], void>({
            query: () => 'cookbook/recipe/',
        }),
        getRecipe: build.query<Recipe, number>({
            query: (id) => `cookbook/recipe/${id}`,
        }),
        getVerbConjugation: build.query<VerbConjugation, string>({
            query: (verb) => `word_conjugation/${encodeURIComponent(verb)}`,
        }),
    }),
});

export const { useGetRecipesQuery, useGetRecipeQuery, useGetVerbConjugationQuery } = api;
